import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Row,
  Col,
  Alert,
  Badge,
  Accordion,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import {
  doc,
  getDoc,
  updateDoc,
  getDocs,
  collection,
  addDoc,
  query,
  where,
  getFirestore,
  serverTimestamp,
} from "firebase/firestore";
import { useNavigate, useParams } from "react-router-dom";
import {
  FaGraduationCap,
  FaPlus,
  FaTrash,
  FaSave,
  FaBook,
  FaVideo,
  FaFilePdf,
  FaQuestionCircle,
  FaArrowLeft,
  FaTimes,
  FaYoutube,
  FaUpload,
  FaEdit,
} from "react-icons/fa";
import firebaseApp from "../../firebase/credenciales";
import { logBusinessAction } from "../../services/AuditService";

const db = getFirestore(firebaseApp);

const EditarCursoPage = ({ usuario }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [categorias, setCategorias] = useState(["Seguridad", "Inducción", "Calidad", "Salud Ocupacional", "Habilidades Blandas"]);
  const [usuariosEmpresa, setUsuariosEmpresa] = useState([]);
  const [firmasPorDni, setFirmasPorDni] = useState({});
  const [mostrarNuevaCategoria, setMostrarNuevaCategoria] = useState(false);
  const [nuevaCategoria, setNuevaCategoria] = useState("");

  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    categoria: "",
    fechaInicio: "",
    fechaFin: "",
    duracionHoras: 1,
    asignadoA: ["TODOS"],
    activo: true,
    tipoRegistroSunafil: "CAPACITACION",
    horasSunafil: 1,
    capacitadorDni: "",
    capacitadorSunafil: "OSCAR CRISTH RODRIGUEZ ARCE",
    cargoCapacitador: "CEO",
    firmaCapacitadorUrl: "",
    organizadorDni: "",
    organizador: "OSCAR CRISTH RODRIGUEZ ARCE",
    cargoOrganizador: "",
    firmaOrganizadorUrl: "",
    sedeAdministrativa:
      "OTR.MZ RE LOTE 05 MZA. RE LOTE. 05 C.H. LA ESTANCIA DE LURIN",
    temaSunafil: "",
    codigoFormatoSunafil: "DIRIS-SST-F-006",
    versionFormatoSunafil: "01",
    fechaFormatoSunafil: "28/02/23",
    modulos: [],
  });
  const [originalData, setOriginalData] = useState(null);

  // Cargar categorías personalizadas si existen
  useEffect(() => {
    const cargarCategorias = async () => {
      try {
        const rucEmpresa = usuario?.ruc || "";
        const categoriasRef = collection(db, `in_capacitacion/${rucEmpresa}/categorias`);
        const snapshot = await getDocs(categoriasRef);
        const docs = snapshot.docs.map(doc => doc.data().nombre);
        if (docs.length > 0) {
          setCategorias(prev => [...new Set([...prev, ...docs])]);
        }
      } catch (err) {
        console.error("Error al cargar categorías:", err);
      }
    };
    if (usuario?.ruc) cargarCategorias();
  }, [usuario]);

  useEffect(() => {
    if (usuario?.ruc && id) {
      cargarCurso();
    }
  }, [usuario, id]);

  useEffect(() => {
    if (usuario?.ruc) {
      cargarUsuariosYFirmas();
    }
  }, [usuario]);

  const nombreCompletoUsuario = (user) =>
    `${user?.name || ""} ${user?.apellidos || ""}`.trim();

  const cargarUsuariosYFirmas = async () => {
    try {
      const rucEmpresa = usuario?.ruc || "";
      const qUsuarios = query(
        collection(db, "users"),
        where("rucEmpresa", "==", rucEmpresa)
      );
      const usersSnap = await getDocs(qUsuarios);
      const usersData = usersSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setUsuariosEmpresa(usersData);
      const mapaFirmas = {};
      const dnis = usersData
        .map((u) => String(u.dni || u.id || ""))
        .filter(Boolean);
      const CHUNK_SIZE = 30;
      for (let i = 0; i < dnis.length; i += CHUNK_SIZE) {
        const chunk = dnis.slice(i, i + CHUNK_SIZE);
        const qFirmas = query(
          collection(db, "firmas"),
          where("__name__", "in", chunk)
        );
        const firmasSnap = await getDocs(qFirmas);
        firmasSnap.forEach((d) => {
          const data = d.data() || {};
          const dni = data.dni || d.id;
          if (!dni) return;
          if (data.ruc && data.ruc !== rucEmpresa) return;
          mapaFirmas[String(dni)] = data.link || data.firmaUrl || data.url || "";
        });
      }
      setFirmasPorDni(mapaFirmas);
    } catch (err) {
      console.error("Error al cargar usuarios/firmas:", err);
    }
  };

  const actualizarPersonaDesdeDni = (tipo, dni) => {
    const user = usuariosEmpresa.find((u) => String(u.dni || u.id) === String(dni));
    const nombre = user ? nombreCompletoUsuario(user) : "";
    const cargo = user?.cargo || "";
    const firma = firmasPorDni[dni] || "";

    if (tipo === "capacitador") {
      setFormData((prev) => ({
        ...prev,
        capacitadorDni: dni,
        capacitadorSunafil: nombre,
        cargoCapacitador: cargo,
        firmaCapacitadorUrl: firma,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      organizadorDni: dni,
      organizador: nombre,
      cargoOrganizador: cargo,
      firmaOrganizadorUrl: firma,
    }));
  };

  const cargarCurso = async () => {
    try {
      setLoading(true);
      const rucEmpresa = usuario?.ruc || "";

      const cursoRef = doc(
        db,
        `in_capacitacion/${rucEmpresa}/programas`,
        id
      );
      const cursoSnap = await getDoc(cursoRef);

      if (!cursoSnap.exists()) {
        setError("Curso no encontrado");
        setTimeout(() => navigate("/capacitaciones"), 2000);
        return;
      }

      const cursoData = cursoSnap.data();

      const cursoFormato = {
        nombre: cursoData.nombre || "",
        descripcion: cursoData.descripcion || "",
        categoria: cursoData.categoria || "Seguridad",
        fechaInicio: cursoData.fechaInicio || "",
        fechaFin: cursoData.fechaFin || "",
        duracionHoras: cursoData.duracionHoras || 1,
        asignadoA: Array.isArray(cursoData.asignadoA)
          ? cursoData.asignadoA
          : ["TODOS"],
        activo: cursoData.activo !== false,
        tipoRegistroSunafil: cursoData.tipoRegistroSunafil || "CAPACITACION",
        horasSunafil: Number(cursoData.horasSunafil ?? cursoData.duracionHoras) || 1,
        capacitadorDni: cursoData.capacitadorDni || "",
        capacitadorSunafil:
          cursoData.capacitadorSunafil || "OSCAR CRISTH RODRIGUEZ ARCE",
        cargoCapacitador: cursoData.cargoCapacitador || "CEO",
        firmaCapacitadorUrl: cursoData.firmaCapacitadorUrl || "",
        organizadorDni: cursoData.organizadorDni || "",
        organizador: cursoData.organizador || "OSCAR CRISTH RODRIGUEZ ARCE",
        cargoOrganizador: cursoData.cargoOrganizador || "",
        firmaOrganizadorUrl: cursoData.firmaOrganizadorUrl || "",
        sedeAdministrativa:
          cursoData.sedeAdministrativa ||
          "OTR.MZ RE LOTE 05 MZA. RE LOTE. 05 C.H. LA ESTANCIA DE LURIN",
        temaSunafil: cursoData.temaSunafil || cursoData.nombre || "",
        codigoFormatoSunafil: cursoData.codigoFormatoSunafil || "DIRIS-SST-F-006",
        versionFormatoSunafil: cursoData.versionFormatoSunafil || "01",
        fechaFormatoSunafil: cursoData.fechaFormatoSunafil || "28/02/23",
        modulos: (cursoData.modulos || []).map((modulo, index) => ({
          ...modulo,
          duracionMinutos: Number(modulo.duracionMinutos) || 10,
          obligatorio: modulo.obligatorio !== false,
          orden: Number(modulo.orden) || index + 1,
        })),
      };
      setFormData(cursoFormato);
      setOriginalData(cursoFormato);
    } catch (err) {
      console.error("Error al cargar curso:", err);
      setError("Error al cargar el curso");
    } finally {
      setLoading(false);
    }
  };

  // Agregar nuevo módulo
  const agregarModulo = () => {
    setFormData({
      ...formData,
      modulos: [
        ...formData.modulos,
        {
          titulo: "",
          descripcion: "",
          videoURL: "",
          pdfURL: "",
          duracionMinutos: 10,
          obligatorio: true,
          orden: formData.modulos.length + 1,
          preguntas: [],
        },
      ],
    });
  };

  // Eliminar módulo
  const eliminarModulo = (index) => {
    const nuevosModulos = formData.modulos.filter((_, i) => i !== index);
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Actualizar módulo
  const actualizarModulo = (index, campo, valor) => {
    const nuevosModulos = [...formData.modulos];
    nuevosModulos[index] = { ...nuevosModulos[index], [campo]: valor };
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Agregar pregunta a módulo
  const agregarPregunta = (moduloIndex) => {
    const nuevosModulos = [...formData.modulos];
    nuevosModulos[moduloIndex].preguntas.push({
      pregunta: "",
      opciones: ["", ""],
      correcta: 0,
    });
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Eliminar pregunta
  const eliminarPregunta = (moduloIndex, preguntaIndex) => {
    const nuevosModulos = [...formData.modulos];
    nuevosModulos[moduloIndex].preguntas = nuevosModulos[
      moduloIndex
    ].preguntas.filter((_, i) => i !== preguntaIndex);
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Actualizar pregunta
  const actualizarPregunta = (moduloIndex, preguntaIndex, campo, valor) => {
    const nuevosModulos = [...formData.modulos];
    nuevosModulos[moduloIndex].preguntas[preguntaIndex] = {
      ...nuevosModulos[moduloIndex].preguntas[preguntaIndex],
      [campo]: valor,
    };
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Agregar opción a pregunta
  const agregarOpcion = (moduloIndex, preguntaIndex) => {
    const nuevosModulos = [...formData.modulos];
    nuevosModulos[moduloIndex].preguntas[preguntaIndex].opciones.push("");
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Eliminar opción
  const eliminarOpcion = (moduloIndex, preguntaIndex, opcionIndex) => {
    const nuevosModulos = [...formData.modulos];
    const pregunta = nuevosModulos[moduloIndex].preguntas[preguntaIndex];
    pregunta.opciones = pregunta.opciones.filter((_, i) => i !== opcionIndex);
    
    // Ajustar el índice de la respuesta correcta si es necesario
    if (pregunta.correcta >= opcionIndex && pregunta.correcta > 0) {
      pregunta.correcta--;
    }
    
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Actualizar opción
  const actualizarOpcion = (moduloIndex, preguntaIndex, opcionIndex, valor) => {
    const nuevosModulos = [...formData.modulos];
    nuevosModulos[moduloIndex].preguntas[preguntaIndex].opciones[opcionIndex] =
      valor;
    setFormData({ ...formData, modulos: nuevosModulos });
  };

  // Validar formulario
  const validarFormulario = () => {
    if (!formData.nombre.trim()) {
      setError("El nombre del curso es obligatorio");
      return false;
    }

    if (!formData.descripcion.trim()) {
      setError("La descripción del curso es obligatoria");
      return false;
    }

    if (formData.modulos.length === 0) {
      setError("Debes agregar al menos un módulo");
      return false;
    }

    for (let i = 0; i < formData.modulos.length; i++) {
      const modulo = formData.modulos[i];

      if (!modulo.titulo.trim()) {
        setError(`El título del módulo ${i + 1} es obligatorio`);
        return false;
      }

      if (!modulo.descripcion.trim()) {
        setError(`La descripción del módulo ${i + 1} es obligatoria`);
        return false;
      }

      for (let j = 0; j < modulo.preguntas.length; j++) {
        const pregunta = modulo.preguntas[j];

        if (!pregunta.pregunta.trim()) {
          setError(
            `La pregunta ${j + 1} del módulo ${i + 1} no puede estar vacía`
          );
          return false;
        }

        if (pregunta.opciones.length < 2) {
          setError(
            `La pregunta ${j + 1} del módulo ${i + 1} debe tener al menos 2 opciones`
          );
          return false;
        }

        for (let k = 0; k < pregunta.opciones.length; k++) {
          if (!pregunta.opciones[k].trim()) {
            setError(
              `La opción ${k + 1} de la pregunta ${j + 1} del módulo ${
                i + 1
              } no puede estar vacía`
            );
            return false;
          }
        }
      }
    }

    return true;
  };

  // Guardar cambios
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validarFormulario()) {
      return;
    }

    try {
      setLoadingSave(true);
      const rucEmpresa = usuario?.ruc || "";

      const cursoData = {
        nombre: formData.nombre.trim(),
        descripcion: formData.descripcion.trim(),
        asignadoA: ["TODOS"],
        activo: formData.activo !== false,
        tipoRegistroSunafil: formData.tipoRegistroSunafil || "CAPACITACION",
        horasSunafil: Number(formData.duracionHoras) || 1,
        capacitadorDni: (formData.capacitadorDni || "").trim(),
        capacitadorSunafil: (formData.capacitadorSunafil || "").trim(),
        cargoCapacitador: (formData.cargoCapacitador || "").trim(),
        firmaCapacitadorUrl: (formData.firmaCapacitadorUrl || "").trim(),
        organizadorDni: (formData.organizadorDni || "").trim(),
        organizador: (formData.organizador || "").trim(),
        cargoOrganizador: (formData.cargoOrganizador || "").trim(),
        firmaOrganizadorUrl: (formData.firmaOrganizadorUrl || "").trim(),
        sedeAdministrativa: (formData.sedeAdministrativa || "").trim(),
        temaSunafil: (formData.temaSunafil || formData.nombre || "").trim(),
        codigoFormatoSunafil: (formData.codigoFormatoSunafil || "").trim(),
        versionFormatoSunafil: (formData.versionFormatoSunafil || "").trim(),
        fechaFormatoSunafil: (formData.fechaFormatoSunafil || "").trim(),
        categoria: formData.categoria === "OTRA" ? nuevaCategoria.trim() : formData.categoria,
        fechaInicio: formData.fechaInicio || null,
        fechaFin: formData.fechaFin || null,
        duracionHoras: Number(formData.duracionHoras) || 1,
        modulos: formData.modulos.map((modulo, index) => ({
          titulo: modulo.titulo.trim(),
          descripcion: modulo.descripcion.trim(),
          videoURL: modulo.videoURL.trim(),
          pdfURL: modulo.pdfURL.trim(),
          duracionMinutos: Number(modulo.duracionMinutos) || 10,
          obligatorio: modulo.obligatorio !== false,
          orden: Number(modulo.orden) || index + 1,
          preguntas: modulo.preguntas.map((pregunta) => ({
            pregunta: pregunta.pregunta.trim(),
            opciones: pregunta.opciones.map((op) => op.trim()),
            correcta: pregunta.correcta,
          })),
        })),
        fechaActualizacion: serverTimestamp(),
      };

      // Si es una nueva categoría, guardarla
      if (formData.categoria === "OTRA" && nuevaCategoria.trim()) {
        const catRef = collection(db, `in_capacitacion/${rucEmpresa}/categorias`);
        await addDoc(catRef, { nombre: nuevaCategoria.trim(), fecha: new Date() });
      }

      const cursoRef = doc(
        db,
        `in_capacitacion/${rucEmpresa}/programas`,
        id
      );
      await updateDoc(cursoRef, cursoData);

      // AUDITORÍA INTELIGENTE
      try {
        const cambios = {};
        if (originalData.nombre !== cursoData.nombre) cambios.nombre = { anterior: originalData.nombre, nuevo: cursoData.nombre };
        if (originalData.categoria !== cursoData.categoria) cambios.categoria = { anterior: originalData.categoria, nuevo: cursoData.categoria };
        if (originalData.duracionHoras !== cursoData.duracionHoras) cambios.duracionHoras = { anterior: originalData.duracionHoras, nuevo: cursoData.duracionHoras };
        if (originalData.modulos.length !== cursoData.modulos.length) cambios.cantidadModulos = { anterior: originalData.modulos.length, nuevo: cursoData.modulos.length };

        if (Object.keys(cambios).length > 0) {
          await logBusinessAction("EDICION_CURSO", "GestionCapacitaciones", {
            cursoId: id,
            cambiosRealizados: cambios
          }, usuario);
        }
      } catch (e) {
        console.warn("No se pudo registrar la auditoría de edición de curso", e);
      }

      setSuccess("¡Curso actualizado exitosamente!");

      setTimeout(() => {
        navigate(`/capacitaciones/curso/${id}`);
      }, 2000);
    } catch (error) {
      console.error("Error al actualizar curso:", error);
      setError("Error al actualizar el curso. Por favor, intenta de nuevo.");
    } finally {
      setLoadingSave(false);
    }
  };

  if (loading) {
    return (
      <div
        className="min-vh-100"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          minHeight: "100vh",
          width: "100vw",
          maxWidth: "100%",
          padding: "20px 0",
        }}
      >
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
          style={{ zIndex: 1080 }}
        >
          <div className="text-center">
            <Spinner
              animation="border"
              variant="light"
              style={{ width: "3rem", height: "3rem" }}
            />
            <p className="text-white mt-3 mb-0">Cargando curso...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Indicador de carga para operaciones */}
        {loadingSave && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
            style={{ zIndex: 1080 }}
          >
            <div className="text-center">
              <Spinner
                animation="border"
                variant="light"
                style={{ width: "3rem", height: "3rem" }}
              />
              <p className="text-white mt-3 mb-0">Guardando cambios...</p>
            </div>
          </div>
        )}

        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium con degradado plomo para Capacitaciones */}
          <Card.Header
            className="text-white py-4"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderBottom: "3px solid #8b9dc3",
            }}
          >
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaEdit className="me-3" />
                Editar Curso
              </h2>
              <p className="mb-0 opacity-75">
                Modifica la información del curso de capacitación
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Alertas */}
            {error && (
              <Alert
                variant="danger"
                dismissible
                onClose={() => setError("")}
                className="mb-4"
              >
                <Alert.Heading>Error</Alert.Heading>
                <p className="mb-0">{error}</p>
              </Alert>
            )}

            {success && (
              <Alert variant="success" className="mb-4">
                <Alert.Heading>¡Éxito!</Alert.Heading>
                <p className="mb-0">{success}</p>
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              {/* Información General del Curso */}
              <Card
                className="shadow-sm border-0 mb-4"
                style={{ borderRadius: "15px" }}
              >
                <Card.Header
                  className="text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "15px 15px 0 0",
                  }}
                >
                  <h5 className="mb-0 fw-semibold">
                    <FaGraduationCap className="me-2" />
                    Información General
                  </h5>
                </Card.Header>
                <Card.Body className="p-4">
                  <Row>
                    <Col md={12} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Nombre del Curso *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Ej: Introducción a la Seguridad Laboral"
                          value={formData.nombre}
                          onChange={(e) =>
                            setFormData({ ...formData, nombre: e.target.value })
                          }
                          required
                          style={{
                            borderRadius: "10px",
                            border: "2px solid #e9ecef",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Categoría *</Form.Label>
                        <Form.Select
                          value={formData.categoria}
                          onChange={(e) => {
                            setFormData({ ...formData, categoria: e.target.value });
                            setMostrarNuevaCategoria(e.target.value === "OTRA");
                          }}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        >
                          {categorias.map((cat) => (
                            <option key={cat} value={cat}>{cat}</option>
                          ))}
                          <option value="OTRA">+ Agregar Nueva Categoría</option>
                        </Form.Select>
                      </Form.Group>
                      {mostrarNuevaCategoria && (
                        <Form.Control
                          type="text"
                          placeholder="Nombre de la nueva categoría"
                          value={nuevaCategoria}
                          onChange={(e) => setNuevaCategoria(e.target.value)}
                          className="mt-2"
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      )}
                    </Col>
                    <Col md={2} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Fecha Inicio</Form.Label>
                        <Form.Control
                          type="date"
                          value={formData.fechaInicio}
                          onChange={(e) => setFormData({ ...formData, fechaInicio: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Fecha Fin</Form.Label>
                        <Form.Control
                          type="date"
                          value={formData.fechaFin}
                          onChange={(e) => setFormData({ ...formData, fechaFin: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Duración (Horas)</Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          value={formData.duracionHoras}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              duracionHoras: e.target.value,
                              horasSunafil: e.target.value,
                            })
                          }
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Descripción *
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Describe el contenido y objetivos del curso..."
                          value={formData.descripcion}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              descripcion: e.target.value,
                            })
                          }
                          required
                          style={{
                            borderRadius: "10px",
                            border: "2px solid #e9ecef",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3} className="mb-3 mt-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Tipo Registro</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.tipoRegistroSunafil}
                          onChange={(e) => setFormData({ ...formData, tipoRegistroSunafil: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={9} className="mb-3 mt-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Tema</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.temaSunafil}
                          onChange={(e) => setFormData({ ...formData, temaSunafil: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">DNI Capacitador</Form.Label>
                        <Form.Select
                          value={formData.capacitadorDni || ""}
                          onChange={(e) => actualizarPersonaDesdeDni("capacitador", e.target.value)}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        >
                          <option value="">Seleccione un colaborador</option>
                          {usuariosEmpresa.map((u) => {
                            const dni = String(u.dni || u.id || "");
                            const nombre = nombreCompletoUsuario(u) || dni;
                            return (
                              <option key={`cap-${dni}`} value={dni}>
                                {dni} - {nombre}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Capacitador</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.capacitadorSunafil}
                          onChange={(e) => setFormData({ ...formData, capacitadorSunafil: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Cargo Capacitador</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.cargoCapacitador}
                          onChange={(e) => setFormData({ ...formData, cargoCapacitador: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Firma Capacitador (URL)</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.firmaCapacitadorUrl || ""}
                          onChange={(e) => setFormData({ ...formData, firmaCapacitadorUrl: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Organizador</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.organizador}
                          onChange={(e) => setFormData({ ...formData, organizador: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">DNI Organizador</Form.Label>
                        <Form.Select
                          value={formData.organizadorDni || ""}
                          onChange={(e) => actualizarPersonaDesdeDni("organizador", e.target.value)}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        >
                          <option value="">Seleccione un colaborador</option>
                          {usuariosEmpresa.map((u) => {
                            const dni = String(u.dni || u.id || "");
                            const nombre = nombreCompletoUsuario(u) || dni;
                            return (
                              <option key={`org-${dni}`} value={dni}>
                                {dni} - {nombre}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Cargo Organizador</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.cargoOrganizador || ""}
                          onChange={(e) => setFormData({ ...formData, cargoOrganizador: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Firma Organizador (URL)</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.firmaOrganizadorUrl || ""}
                          onChange={(e) => setFormData({ ...formData, firmaOrganizadorUrl: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Sede Administrativa</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.sedeAdministrativa}
                          onChange={(e) => setFormData({ ...formData, sedeAdministrativa: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-1">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Código Formato</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.codigoFormatoSunafil}
                          onChange={(e) => setFormData({ ...formData, codigoFormatoSunafil: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-1">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Versión Formato</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.versionFormatoSunafil}
                          onChange={(e) => setFormData({ ...formData, versionFormatoSunafil: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-1">
                      <Form.Group>
                        <Form.Label className="fw-semibold">Fecha Formato</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.fechaFormatoSunafil}
                          onChange={(e) => setFormData({ ...formData, fechaFormatoSunafil: e.target.value })}
                          style={{ borderRadius: "10px", border: "2px solid #e9ecef" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Módulos del Curso */}
              <Card
                className="shadow-sm border-0 mb-4"
                style={{ borderRadius: "15px" }}
              >
                <Card.Header
                  className="text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "15px 15px 0 0",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="mb-0 fw-semibold">
                        <FaBook className="me-2" />
                        Módulos del Curso
                      </h5>
                      <small className="opacity-75">
                        Agrega el contenido educativo del curso
                      </small>
                    </div>
                    <Badge bg="light" text="dark" style={{ fontSize: "0.9rem" }}>
                      {formData.modulos.length} módulos
                    </Badge>
                  </div>
                </Card.Header>
                <Card.Body className="p-4">
                  {formData.modulos.length === 0 ? (
                    <div className="text-center py-5">
                      <FaBook size={48} className="text-muted mb-3" />
                      <p className="text-muted mb-3">
                        No hay módulos agregados aún
                      </p>
                      <Button
                        className="d-flex align-items-center gap-2 mx-auto text-white"
                        onClick={agregarModulo}
                        style={{
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                        }}
                      >
                        <FaPlus size="14px" />
                        Agregar Primer Módulo
                      </Button>
                    </div>
                  ) : (
                    <>
                      <Accordion>
                        {formData.modulos.map((modulo, moduloIndex) => (
                          <Accordion.Item
                            key={moduloIndex}
                            eventKey={moduloIndex.toString()}
                            style={{
                              borderRadius: "10px",
                              marginBottom: "15px",
                              border: "2px solid #e9ecef",
                            }}
                          >
                            <Accordion.Header>
                              <div className="d-flex align-items-center w-100">
                                <Badge
                                  style={{
                                    fontSize: "0.75rem",
                                    background:
                                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    border: "none",
                                    marginRight: "10px",
                                  }}
                                  className="px-2 py-1"
                                >
                                  {moduloIndex + 1}
                                </Badge>
                                <span className="fw-semibold">
                                  {modulo.titulo || `Módulo ${moduloIndex + 1}`}
                                </span>
                                {modulo.preguntas.length > 0 && (
                                  <Badge
                                    bg="info"
                                    className="ms-2"
                                    style={{ fontSize: "0.7rem" }}
                                  >
                                    {modulo.preguntas.length} preguntas
                                  </Badge>
                                )}
                              </div>
                            </Accordion.Header>
                            <Accordion.Body
                              style={{ backgroundColor: "#fff", padding: "20px" }}
                            >
                              <Row className="mb-3">
                                <Col md={12} className="mb-3">
                                  <Form.Group>
                                    <Form.Label className="fw-semibold">
                                      Título del Módulo *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Ej: Introducción a la Seguridad"
                                      value={modulo.titulo}
                                      onChange={(e) =>
                                        actualizarModulo(
                                          moduloIndex,
                                          "titulo",
                                          e.target.value
                                        )
                                      }
                                      required
                                      style={{
                                        borderRadius: "10px",
                                        border: "2px solid #e9ecef",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={12} className="mb-3">
                                  <Form.Group>
                                    <Form.Label className="fw-semibold">
                                      Descripción *
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      rows={2}
                                      placeholder="Describe el contenido de este módulo..."
                                      value={modulo.descripcion}
                                      onChange={(e) =>
                                        actualizarModulo(
                                          moduloIndex,
                                          "descripcion",
                                          e.target.value
                                        )
                                      }
                                      required
                                      style={{
                                        borderRadius: "10px",
                                        border: "2px solid #e9ecef",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <Form.Group>
                                    <Form.Label className="fw-semibold">
                                      <FaYoutube className="me-2 text-danger" />
                                      URL del Video (YouTube)
                                    </Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaVideo />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="url"
                                        placeholder="https://www.youtube.com/watch?v=..."
                                        value={modulo.videoURL}
                                        onChange={(e) =>
                                          actualizarModulo(
                                            moduloIndex,
                                            "videoURL",
                                            e.target.value
                                          )
                                        }
                                        style={{
                                          borderRadius: "0 10px 10px 0",
                                          border: "2px solid #e9ecef",
                                        }}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <Form.Group>
                                    <Form.Label className="fw-semibold">
                                      <FaFilePdf className="me-2 text-danger" />
                                      URL del PDF
                                    </Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FaUpload />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="url"
                                        placeholder="https://..."
                                        value={modulo.pdfURL}
                                        onChange={(e) =>
                                          actualizarModulo(
                                            moduloIndex,
                                            "pdfURL",
                                            e.target.value
                                          )
                                        }
                                        style={{
                                          borderRadius: "0 10px 10px 0",
                                          border: "2px solid #e9ecef",
                                        }}
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <Form.Group>
                                    <Form.Label className="fw-semibold">
                                      Duración (min)
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      min="1"
                                      value={modulo.duracionMinutos || 10}
                                      onChange={(e) =>
                                        actualizarModulo(
                                          moduloIndex,
                                          "duracionMinutos",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        borderRadius: "10px",
                                        border: "2px solid #e9ecef",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <Form.Group>
                                    <Form.Label className="fw-semibold">
                                      Orden
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      min="1"
                                      value={modulo.orden || moduloIndex + 1}
                                      onChange={(e) =>
                                        actualizarModulo(
                                          moduloIndex,
                                          "orden",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        borderRadius: "10px",
                                        border: "2px solid #e9ecef",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={4} className="mb-3 d-flex align-items-end">
                                  <Form.Check
                                    type="switch"
                                    id={`obligatorio-${moduloIndex}`}
                                    label="Módulo obligatorio"
                                    checked={modulo.obligatorio !== false}
                                    onChange={(e) =>
                                      actualizarModulo(
                                        moduloIndex,
                                        "obligatorio",
                                        e.target.checked
                                      )
                                    }
                                  />
                                </Col>
                              </Row>

                              {/* Preguntas del Módulo */}
                              <div
                                className="p-3 mb-3"
                                style={{
                                  background: "#f8f9fa",
                                  borderRadius: "10px",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <h6 className="fw-semibold mb-0">
                                    <FaQuestionCircle className="me-2" />
                                    Preguntas de Evaluación
                                  </h6>
                                  <Button
                                    size="sm"
                                    variant="outline-primary"
                                    onClick={() => agregarPregunta(moduloIndex)}
                                    className="d-flex align-items-center gap-1"
                                    style={{
                                      borderRadius: "8px",
                                      borderColor: "#667eea",
                                      color: "#667eea",
                                    }}
                                  >
                                    <FaPlus size="10px" />
                                    Agregar Pregunta
                                  </Button>
                                </div>

                                {modulo.preguntas.length === 0 ? (
                                  <p className="text-muted text-center mb-0">
                                    No hay preguntas agregadas
                                  </p>
                                ) : (
                                  modulo.preguntas.map(
                                    (pregunta, preguntaIndex) => (
                                      <Card
                                        key={preguntaIndex}
                                        className="mb-3 border-0 shadow-sm"
                                        style={{ borderRadius: "10px" }}
                                      >
                                        <Card.Body>
                                          <div className="d-flex justify-content-between align-items-start mb-3">
                                            <Badge
                                              bg="secondary"
                                              style={{ fontSize: "0.75rem" }}
                                            >
                                              Pregunta {preguntaIndex + 1}
                                            </Badge>
                                            <Button
                                              size="sm"
                                              variant="outline-danger"
                                              onClick={() =>
                                                eliminarPregunta(
                                                  moduloIndex,
                                                  preguntaIndex
                                                )
                                              }
                                              style={{
                                                borderRadius: "6px",
                                                padding: "2px 8px",
                                              }}
                                            >
                                              <FaTimes size="10px" />
                                            </Button>
                                          </div>

                                          <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold small">
                                              Pregunta *
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Escribe la pregunta..."
                                              value={pregunta.pregunta}
                                              onChange={(e) =>
                                                actualizarPregunta(
                                                  moduloIndex,
                                                  preguntaIndex,
                                                  "pregunta",
                                                  e.target.value
                                                )
                                              }
                                              required
                                              style={{
                                                borderRadius: "8px",
                                                border: "2px solid #e9ecef",
                                              }}
                                            />
                                          </Form.Group>

                                          <Form.Label className="fw-semibold small">
                                            Opciones de Respuesta *
                                          </Form.Label>
                                          {pregunta.opciones.map(
                                            (opcion, opcionIndex) => (
                                              <InputGroup
                                                key={opcionIndex}
                                                className="mb-2"
                                              >
                                                <Form.Check
                                                  type="radio"
                                                  name={`correcta-${moduloIndex}-${preguntaIndex}`}
                                                  checked={
                                                    pregunta.correcta ===
                                                    opcionIndex
                                                  }
                                                  onChange={() =>
                                                    actualizarPregunta(
                                                      moduloIndex,
                                                      preguntaIndex,
                                                      "correcta",
                                                      opcionIndex
                                                    )
                                                  }
                                                  className="me-2 mt-2"
                                                />
                                                <Form.Control
                                                  type="text"
                                                  placeholder={`Opción ${
                                                    opcionIndex + 1
                                                  }`}
                                                  value={opcion}
                                                  onChange={(e) =>
                                                    actualizarOpcion(
                                                      moduloIndex,
                                                      preguntaIndex,
                                                      opcionIndex,
                                                      e.target.value
                                                    )
                                                  }
                                                  required
                                                  style={{
                                                    borderRadius: "8px",
                                                    border: "2px solid #e9ecef",
                                                  }}
                                                />
                                                {pregunta.opciones.length > 2 && (
                                                  <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() =>
                                                      eliminarOpcion(
                                                        moduloIndex,
                                                        preguntaIndex,
                                                        opcionIndex
                                                      )
                                                    }
                                                    style={{
                                                      borderRadius: "0 8px 8px 0",
                                                    }}
                                                  >
                                                    <FaTimes size="10px" />
                                                  </Button>
                                                )}
                                              </InputGroup>
                                            )
                                          )}
                                          <Button
                                            size="sm"
                                            variant="outline-secondary"
                                            onClick={() =>
                                              agregarOpcion(
                                                moduloIndex,
                                                preguntaIndex
                                              )
                                            }
                                            className="mt-2"
                                            style={{ borderRadius: "8px" }}
                                          >
                                            <FaPlus size="10px" className="me-1" />
                                            Agregar Opción
                                          </Button>
                                        </Card.Body>
                                      </Card>
                                    )
                                  )
                                )}
                              </div>

                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => eliminarModulo(moduloIndex)}
                                className="w-100 d-flex align-items-center justify-content-center gap-2"
                                style={{ borderRadius: "10px" }}
                              >
                                <FaTrash size="12px" />
                                Eliminar Módulo
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>

                      <Button
                        className="w-100 d-flex align-items-center justify-content-center gap-2 mt-3 text-white"
                        onClick={agregarModulo}
                        style={{
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                        }}
                      >
                        <FaPlus size="14px" />
                        Agregar Otro Módulo
                      </Button>
                    </>
                  )}
                </Card.Body>
              </Card>

              {/* Botones de Acción */}
              <Card
                className="shadow-sm border-0"
                style={{ borderRadius: "15px" }}
              >
                <Card.Body className="p-4">
                  <Row>
                    <Col md={6}>
                      <Button
                        variant="outline-secondary"
                        size="lg"
                        onClick={() => navigate(-1)}
                        className="w-100 d-flex align-items-center justify-content-center gap-2"
                        style={{ borderRadius: "10px" }}
                        disabled={loadingSave}
                      >
                        <FaArrowLeft size="16px" />
                        Cancelar
                      </Button>
                    </Col>
                    <Col md={6}>
                      <Button
                        type="submit"
                        size="lg"
                        className="w-100 d-flex align-items-center justify-content-center gap-2 text-white"
                        disabled={loadingSave}
                        style={{
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                        }}
                      >
                        {loadingSave ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            Guardando...
                          </>
                        ) : (
                          <>
                            <FaSave size="16px" />
                            Guardar Cambios
                          </>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default EditarCursoPage;
